var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 35 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2B6638",
  d: "M1.681 7.077H1v4.04h.681zm32.17 5.258v1.485h-4.47a2.556 2.556 0 0 1-4.91 0H13.456a2.558 2.558 0 0 1-4.912 0H1.683v-1.485h.774v-5.45L5.58.334h27.643v12z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M33.852 12.334v1.485h-4.47a2.4 2.4 0 0 0 .102-.712q-.002-.406-.12-.773z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M33.224.335v12h-3.86a2.556 2.556 0 0 0-4.872 0H13.439a2.558 2.558 0 0 0-4.874 0H2.456v-5.45L5.581.334z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M13.439 12.335a2.558 2.558 0 1 0-4.87 1.547 2.558 2.558 0 0 0 4.87-1.547Zm-.8 1.033q-.039.24-.14.452a1.656 1.656 0 1 1 .14-.452Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M12.659 13.108q0 .133-.021.26a1.656 1.656 0 1 1-3.102-1.033 1.658 1.658 0 0 1 3.123.773Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M29.363 12.335a2.556 2.556 0 1 0-4.874 1.544 2.556 2.556 0 0 0 4.874-1.544Zm-.8 1.033q-.038.24-.14.452a1.654 1.654 0 0 1-3.131-.452 1.654 1.654 0 0 1 1.634-1.918 1.66 1.66 0 0 1 1.636 1.918Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M28.582 13.108q0 .133-.021.26-.038.24-.14.452a1.654 1.654 0 0 1-2.991 0 1.6 1.6 0 0 1-.161-.712 1.656 1.656 0 1 1 3.313 0Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#2B6638",
  stroke: "#2B6638",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M1.681 7.077H1v4.04h.681z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M10.446 6.513H3.964l1.97-4.09h4.512zm10.068-4.09h-6.69v4.09h6.69zm8.97 0h-6.69v4.09h6.69z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5,
  d: "M8.458 13.367q.024.234.088.452H1.683v-1.485h6.882a2.5 2.5 0 0 0-.107 1.033Zm15.926 0q.024.234.088.452H13.458a2.4 2.4 0 0 0 .101-.712q-.002-.406-.12-.773h11.053a2.5 2.5 0 0 0-.108 1.033Z"
})));
export default SvgBus;